import axios from 'axios'
import store from '@/store'

const API_BASE_URL = process.env.VUE_APP_API_URL || 'https://clubtest.intrare.app'

const request = (method, path, { data, params } = {}) => axios({
  method,
  url: `${API_BASE_URL}${path}`,
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': store.state.language,
    'authorization': 'Token ' + store.getters.getToken
  },
  data,
  params
})

// Administracion
export const getClubEvents = params => request('get', '/club-events/', { params })
export const getClubEvent = id => request('get', `/club-events/${id}/`)
export const createClubEvent = data => request('post', '/club-events/', { data })
export const updateClubEvent = (id, data) => request('patch', `/club-events/${id}/`, { data })
export const approveClubEvent = (id, data) => request('post', `/club-events/${id}/approve/`, { data })
export const rejectClubEvent = (id, data) => request('post', `/club-events/${id}/reject/`, { data })
export const cancelClubEvent = id => request('post', `/club-events/${id}/cancel/`)
export const setClubEventPayment = (id, status) => request('post', `/club-events/${id}/payment/`, { data: { status } })
export const addClubEventGuests = (id, guests) => request('post', `/club-events/${id}/guests/`, { data: { guests } })
export const renameClubEventGuest = (id, guestId, fullName) =>
  request('patch', `/club-events/${id}/guests/${guestId}/`, { data: { full_name: fullName } })
export const deleteClubEventGuest = (id, guestId) => request('delete', `/club-events/${id}/guests/${guestId}/`)

// Socio anfitrion
export const getMyClubEvents = params => request('get', '/club-events/mine/', { params })

// Caseta
export const getGateTodayEvents = () => request('get', '/club-events/gate/today/')
export const getGateEventByQr = qrCode => request('get', `/club-events/gate/qr/${encodeURIComponent(qrCode)}/`)
export const setGateGuestStatus = (guestId, status, accessNoCode) => request(
  'patch', `/club-events/gate/guests/${guestId}/status/`,
  { data: accessNoCode ? { status, access_no_code: accessNoCode } : { status } })
